import {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useMemo,
  useState,
} from "react"

import { Flags, FlagsType } from "@/lib/flags"

interface FeatureFlagsContext {
  flags: typeof Flags
  setFlags: Dispatch<SetStateAction<typeof Flags>>
}

const FeatureFlagsContext = createContext<FeatureFlagsContext | null>(null)

export function FeatureFlagsProvider({
  children,
  initialFlags = Flags,
}: {
  children: React.ReactNode
  initialFlags?: typeof Flags
}) {
  const [flags, setFlags] = useState<typeof Flags>(initialFlags)
  const value = useMemo(() => ({ flags, setFlags }), [flags])

  return (
    <FeatureFlagsContext.Provider value={value}>
      {children}
    </FeatureFlagsContext.Provider>
  )
}

export function useFeatureFlagsContext() {
  const context = useContext(FeatureFlagsContext)
  if (context === null) {
    throw new Error(
      "useFeatureFlagsContext may only be used within a FeatureFlagsContext",
    )
  }
  return context
}

export function useFlags() {
  const context = useContext(FeatureFlagsContext)
  if (context === null) {
    throw new Error("useFlags may only be used within a FeatureFlagsContext")
  }
  return context.flags as FlagsType
}
